import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

// Reference card an admin can pull up while reviewing a vendor or a resident for
// approval. The steps come straight from the internal ops review-process doc, so
// the person clicking "Approve"/"Decline" has the standard in front of them.
const PROCESS = {
  vendor: {
    title: "Vendor (Contractor) Review Process",
    intro:
      "Use this when reviewing a contractor before approval. The goal is The Turn Standard: only trusted, high-quality professionals enter the community.",
    sections: [
      {
        heading: "Step 1 — Collect required documentation",
        items: [
          "Business name (legal company name)",
          "Business license (active and valid)",
          "Insurance: general liability, confirmed current, copy retained",
          "Primary business contact email",
          "Website (reviewed for professionalism and service quality)",
          "Trade-specific license number (electrical, plumbing, masonry, and other specialized trades)",
          "Years in business / time in their trade",
          "Portfolio of work in high-end estates or gated communities",
        ],
      },
      {
        heading: "Step 2 — Apply The Turn Standard",
        items: [
          "Proof of Mastery: a master of their trade, not a handyman. Portfolio shows similar high-end work, license numbers check out, and they name their specialty specifically.",
          "Community Compatibility: experience following HOA/POA rules. Prioritize vendors who have already worked for a current resident. Staff are subject to basic background checks.",
          "Professional Reliability: a legitimate business with general liability and workers' comp insurance, committed to a 24 to 48 hour response time.",
          "Resident Safety: familiar with, or willing to follow, the gate security protocols at The Landings.",
        ],
      },
      {
        heading: "Step 3 — Decide",
        items: [
          "Approve only when every item above checks out.",
          "Decline with a clear reason if anything is missing or cannot be verified.",
        ],
      },
    ],
    footnote:
      "Time per review: about 15 to 20 minutes. EIN and bonding are not required at this time.",
  },
  resident: {
    title: "Resident Review Process",
    intro:
      "Use these steps when reviewing a resident before approval. Only verified members of the community should be approved.",
    sections: [
      {
        heading: "Step 1 — Confirm membership",
        items: [
          "Verify the applicant is a current member of the community (geofencing plus your own manual verification).",
        ],
      },
      {
        heading: "Step 2 — No auto-approval",
        items: [
          "Every resident requires manual account approval before they go live. Nothing is approved automatically.",
        ],
      },
      {
        heading: "Step 3 — Renters are eligible",
        items: [
          "Members who rent a home (short-term or long-term) still qualify. Membership is free for members.",
        ],
      },
      {
        heading: "Step 4 — Decide",
        items: [
          "Approve only after you have verified the applicant lives in the neighborhood.",
          "Reject with a reason (for example, could not verify residence) if you cannot confirm it.",
        ],
      },
    ],
    footnote:
      "Time per review: about 5 to 10 minutes. Residents are lower-risk than contractors but still require approval.",
  },
};

const headingStyle = { color: "#1A3C34", fontSize: 16, fontWeight: 700, margin: "18px 0 8px" };
const introStyle = { color: "#555", fontSize: 14, lineHeight: 1.5, marginBottom: 4 };
const itemStyle = { fontSize: 14, lineHeight: 1.55, color: "#1a1a1a", marginBottom: 6 };
const footStyle = { marginTop: 20, paddingTop: 12, borderTop: "1px solid #eee", color: "#777", fontSize: 13, fontStyle: "italic" };

const ReviewProcessModal = ({ type = "resident", show, onClose }) => {
  const content = PROCESS[type] || PROCESS.resident;

  return (
    <Modal show={show} centered scrollable size="lg" onHide={onClose}>
      <button className="closeButton" onClick={onClose}>
        <FontAwesomeIcon icon={faTimes} />
      </button>
      <Modal.Header>
        <Modal.Title style={{ color: "#1A3C34", fontSize: 20 }}>{content.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p style={introStyle}>{content.intro}</p>
        {content.sections.map((section, i) => (
          <div key={i}>
            <div style={headingStyle}>{section.heading}</div>
            <ul style={{ paddingLeft: 20, margin: 0 }}>
              {section.items.map((item, j) => (
                <li key={j} style={itemStyle}>{item}</li>
              ))}
            </ul>
          </div>
        ))}
        <p style={footStyle}>{content.footnote}</p>
      </Modal.Body>
    </Modal>
  );
};

export default ReviewProcessModal;
